import { render } from "./chatbox-editor.vue?vue&type=template&id=7363b838&scoped=true"
import script from "./chatbox-editor.vue?vue&type=script&lang=js"
export * from "./chatbox-editor.vue?vue&type=script&lang=js"

import "./chatbox-editor.vue?vue&type=style&index=0&id=7363b838&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7363b838"]])

export default __exports__